import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { enGetMediaReportsDetail_url } from "@/api"; //引入发送请求获取数据的方法

import { useRoute } from "vue-router";
import { ElMessage } from 'element-plus';
import { onMounted, ref, reactive } from 'vue';
export default {
  components: {},
  name: 'Report',
  setup: function setup() {
    var reportsDetail = ref({});
    var previousReports = ref({});
    var nextReports = ref({});
    var route = useRoute();
    var reportId = route.query.reportId; //路由获取详情id

    onMounted(function () {
      getHomeTopMediaReportsList(reportId);
    });

    var getHomeTopMediaReportsList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var params, res, dateStr, date, monthNames, formattedDate;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  reportId: id
                };
                _context.next = 3;
                return enGetMediaReportsDetail_url(params);

              case 3:
                res = _context.sent;
                // console.log(res,'媒体报道详情');
                dateStr = res.data.reportsDetail.publishDate;
                date = new Date(dateStr);
                monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                formattedDate = monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear(); // console.log(formattedDate);

                res.data.reportsDetail.publishDate = formattedDate;
                reportsDetail.value = res.data.reportsDetail;
                previousReports.value = res.data.previousReports;
                nextReports.value = res.data.nextReports;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getHomeTopMediaReportsList(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var openPdf = function openPdf() {
      var pdfUrl = reportsDetail.value && reportsDetail.value.pdfUrl;
      if (!pdfUrl) return;
      window.open(pdfUrl);
    };

    var getReports = function getReports(report) {
      if (report.jumpFlag == 1) {
        window.open(report.jumpUrl);
      }

      if (!report.reportId) {
        ElMessage('No more available');
        return;
      } // if(){
      // }


      var url = "https://www.tenacia.com/en/mediaDetails?reportId=".concat(report.reportId); // let url = `https://webtest.tenacia.com/en/mediaDetails?reportId=${report.reportId}`  

      window.open(url); // getHomeTopMediaReportsList(reportId)
    };

    return {
      reportsDetail: reportsDetail,
      previousReports: previousReports,
      nextReports: nextReports,
      openPdf: openPdf,
      getReports: getReports
    };
  }
};